import React, { Component } from 'react';
import _ from 'lodash';
import { Theme, createStyles, WithStyles, Tooltip, Typography, withStyles } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
	reviwerName: {
		textTransform: 'capitalize',
		fontWeight: theme.typography.fontWeightRegular,
	},
	userReviewerGrid: {},
	userReviewerInfo: {
		display: 'flex',
		alignItems: 'center',
		'& > span': {
			display: 'inline-block',
		}
	}
});

interface UserReviewerGridProps extends WithStyles<typeof styles> {
	displayName: string,
	allReviewers: any[],
}

interface UserReviewerGridState {
	reviewerName: any,
	reviewerCount: number,
}



class UserReviewerGrid extends Component<UserReviewerGridProps, UserReviewerGridState>{
	constructor(props: UserReviewerGridProps) {
		super(props);
		this.state = {
			reviewerName: '""',
			reviewerCount: 0,
		};

	}
	// return titles for tooltip
	reviewerTitles(allReviewers: any) {
		let titles: any = [];
		let rName = "";
		let rCount = 0;
		_.map(allReviewers, (a, index) => {
			!_.isUndefined(a) && _.map(a.reviewer, (reviewer, index: number) => {
				!_.isUndefined(reviewer) && titles.push(_.get(reviewer, 'fullName', ''))
			});
		});
		let name: any = _.compact(titles);
		rName = name && name.length > 0 ? name[0] : '';
		if (name && name.length > 1) {
			rCount = name.length - 1;
			name.splice(0, 1);
		}
		let data = { name: name && name.length > 0 ? name.join(',') : '', reviewerName: rName, reviewerCount: rCount };
		return data;
	};

	render() {
		const { displayName = '', allReviewers = [], classes } = this.props;
		const { reviewerName = '', reviewerCount = 0 } = this.state;
		let data = this.reviewerTitles(allReviewers)

		return (
			<div className={classes.userReviewerGrid}>
				<Typography variant="body1">
					<strong>Reviewer:</strong>
				</Typography>
				<div className={classes.userReviewerInfo}>
					{_.isEmpty(data.reviewerName) ?
						<Typography variant="body2" color="textSecondary" className={classes.reviwerName}>No reviewer</Typography>
						:
						<Typography variant="body2" className={classes.reviwerName}>{data.reviewerName}</Typography>
					}
					{(data.reviewerCount > 0) && (
						<Tooltip title={data.name}>
							<Typography variant="body2" color="primary" className={classes.reviwerName}>,&nbsp;{(data.reviewerCount)} more</Typography>
						</Tooltip>
					)}
				</div>
			</div>
		)
	}
};

// @ts-ignore
export default withStyles(styles)(UserReviewerGrid);
